module.exports = __webpack_public_path__ + "img/md_logo.9f556631.svg";